export default __webpack_public_path__ + "static/media/partners10.bde878c1.png";